import { styled as o } from "styled-components";
import { MediaQuery as t } from "../../styles/variables.js";
import { Dropdown as r } from "../Dropdown/index.js";
import { dropdownListMobileFullPageStyle as p } from "../Dropdown/components/DropdownList/style.js";
import "react/jsx-runtime";
import "react";
import "react-dom";
const x = o(r.Root)`
  &&& {
    @media ${t.SCREEN_SM} {
      margin-bottom: 0px;
    }
  }
`, l = o(r.List)`
  &&& {
    padding: 0;
    width: 400px;
    border-radius: 0px 0px 8px 8px;

    @media ${t.SCREEN_SM} {
      ${p};
    }
  }
`;
export {
  l as CustomDropdownList,
  x as CustomDropdownRoot
};
